import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit'
import { staticNotification as notification } from '../../common/antd/static-notification.ts'
import { newRelic } from '../../utils/new-relic.ts'

function isErrorAction(
  action: unknown
): action is { payload: { status: string; data: { errorCode: string } } } {
  if (typeof action === 'object' && action !== null && 'payload' in action) {
    const payload = (action as Record<string, unknown>).payload
    if (
      typeof payload === 'object' &&
      payload !== null &&
      'status' in payload &&
      'data' in payload
    ) {
      const data = (payload as Record<string, unknown>).data
      return typeof data === 'object' && data !== null && 'errorCode' in data
    }
  }
  return false
}

export const unauthorizedMiddleware: Middleware = () => (next) => (action) => {
  if (
    isErrorAction(action) &&
    isRejectedWithValue(action) &&
    action.payload.data.errorCode === 'InvalidAuthToken'
  ) {
    // Exclude the pre-login /verify probe: its InvalidAuthToken is expected and
    // must not trigger the "logout in 3 seconds" flow. Mirror auth.middleware's
    // way of reading the request URL from the rejected action's baseQueryMeta.
    const meta = (action as Record<string, unknown>).meta
    const baseQueryMeta =
      typeof meta === 'object' && meta !== null
        ? (meta as Record<string, unknown>).baseQueryMeta
        : undefined
    const request =
      typeof baseQueryMeta === 'object' && baseQueryMeta !== null
        ? (baseQueryMeta as Record<string, unknown>).request
        : undefined
    const requestUrl = request instanceof Request ? request.url : undefined

    if (requestUrl?.includes('/verify')) {
      return next(action)
    }

    notification.error({
      message: 'Auth token expired, logout in 3 seconds',
    })
    newRelic.noticeError(new Error('InvalidAuthToken, forcing logout'), {
      context: 'unauthorizedMiddlewareForcedLogout',
    })

    setTimeout(() => {
      window.location.href = '/logout'
    }, 3000)
  }

  return next(action)
}
